import React from "react";
import { Card, Grid } from "@mui/material";
import Title from "./../ReusableComponents/title";
import HourProfitLossChart from "../Charts/HourProfitLossChart";
import HourResultTable from "./HourResultTable";

const ResultsByOpenHour = ({ data }) => {
  return (
    <Grid item container spacing={2} className='longshort-ctn'>
      <Grid className="longshort-inner" item xs={12} md={6}  sx={{ paddingLeft: { xs: 0 } }}>
        <Card className="card-csc">
          <Title six>Profits by Open hour</Title>
          <HourProfitLossChart data={data} />
        </Card>
      </Grid>
      <Grid className="longshort-inner" item xs={12} md={6}  sx={{ paddingLeft: { xs: 0 } }}>
        <Card className="card-csc">
          <Title six>Results by Open Hour</Title>
          <HourResultTable data={data} />
        </Card>
      </Grid>
    </Grid>
  );
};

export default ResultsByOpenHour;
